//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'

import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/mainstyle.css'
//import './custom.scss'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'wowjs/css/libs/animate.css'
import 'owl.carousel';
import "sweetalert2/dist/sweetalert2.css"

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const WOW = require('wowjs');
window.wow = new WOW.WOW({ live: false });
require('./assets/js/custom');



Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Loading);

Vue.config.productionTip = false;

/*
new Vue({
  render: h => h(App),
}).$mount('#app')
*/


new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})